import { getVm } from '@/helpers/vm-helper';
import { ExperimentTrackEventOptions } from '../Core/types';
import { FTSwiperExpVariants } from '.';

export const trackFreeTrialSwiperExp = (
	TrackingOptions: ExperimentTrackEventOptions<FTSwiperExpVariants>,
	lastRoute = false
) => {
	// const vm = getVm();
	// const activeVariant = vm?.$store.getters['experiment/activeVariantsWithControlGroup'][FTSwiperExpName] ?? null;
	// const fTSwiperExpOSActiveVariant =
	// 	vm?.$store.getters['experiment/activeVariantsWithControlGroup'][FTSwiperExpOSName] ?? null;
	// //QTV_APPLE_EXP
	// // due to similar tracking event between Swiper Exp & QTV APPLE EXP we are reusing the same function.
	// const qtvAppleVariant = vm?.$store.getters['experiment/activeVariantsWithControlGroup'][QtvAppleExpName] ?? null;
	// if (!activeVariant && !fTSwiperExpOSActiveVariant && qtvAppleVariant) {
	// 	trackQTVAppleExp(TrackingOptions, lastRoute);
	// 	return;
	// }
	// //QTV_APPLE_EXP
	// const isUserLoggedIN = !!vm?.$store.getters['user/isLoggedIn'];
	// const lastRouteName = vm?.$store.state.routing.lastRoute?.name;
	// const routeName = lastRoute ? lastRouteName : vm?.$route.name;
	// if (
	// 	(activeVariant || fTSwiperExpOSActiveVariant) &&
	// 	['app.detail.movies', 'app.detail.show', 'app.detail.show.season'].includes(routeName) &&
	// 	!isUserLoggedIN
	// ) {
	// 	const geoCountry = getUserGeoLocation()?.[0];
	// 	const label = TrackingOptions.label?.includes('clickout')
	// 		? `${TrackingOptions.label}_${geoCountry}`
	// 		: TrackingOptions.label;
	// 	//FT_SWIPER_EXP_OS_2
	// 	if (fTSwiperExpOSActiveVariant) {
	// 		FTSwiperExpOS.trackEvent({
	// 			property: 'yo_swiper_os',
	// 			...TrackingOptions,
	// 			label,
	// 		});
	// 		return;
	// 	}
	// 	//FT_SWIPER_EXP_OS_2
	// 	FTSwiperExp.trackEvent({
	// 		property: 'yo_swiper',
	// 		...TrackingOptions,
	// 		label,
	// 	});
	// }
};

export const appleTVSuffixTagByVariant = {
	[FTSwiperExpVariants.CONTROL]: '-swg',
	[FTSwiperExpVariants.VARIANT_1]: '-swg1',
};
